import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

// layouts
import { MainLayout } from "layouts";

// components
import { NotificationIcon } from "components/common";
import { MenuSections, RequestCard, UserProfile } from "components/all";
import Text from "components/ui/Text";

// redux
import { fetchUserInfo } from "redux/slices/user/userSlice";
import { HeaderIcon } from "layouts/HeaderComponents";
import LeftArrow from "assets/icons/left-arrow.svg";

const menuSections = [
  { label: "알림 설정", to: "/all/settings/notifications" },
  { label: "내 센터 설정 관리", to: "/all/settings/maincenter" },
  { label: "약관 및 이용 동의", to: "/all/terms" },
  { label: "앱 버전", to: "" },
];

const All = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const HeaderComponents = {
    leftComponent: () => {
      return (
        <LeftWrap>
          <HeaderIcon onClick={() => navigate(-1)} imageSrc={LeftArrow} />
          <Text
            color="#092349"
            fontSize="20px"
            fontWeight="700"
            lineHeight="24px"
          >
            설정
          </Text>
        </LeftWrap>
      );
    },

    rightComponent: () => {
      return <NotificationIcon />;
    },
  };

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  return (
    <MainLayout
      withHeader={true}
      withBottomTab={false}
      backgroundColor="white"
      headerProps={{
        withBackButton: false,
        padding: "14px 30px 14px 24px",
        leftComponent: HeaderComponents.leftComponent,
        rightComponent: HeaderComponents.rightComponent,
      }}
    >
      <Wrapper>
        <UserProfile />
        <RequestCard />
        <MenuSections page="main" sections={menuSections} />
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 0 20px;
`;

const LeftWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  & > div:first-of-type {
    width: max-content;
    height: max-content;
  }
`;
export default All;
